<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/Text/4start#chap1">Chapter One</a></p>
<p class="toc1"><a href="#/Text/5chap2#chap2">Chapter Two</a></p>
<p class="toc1"><a href="#/Text/6chap3#chap3">Chapter Three</a></p>
<p class="toc1"><a href="#/Text/7chap4#chap4">Chapter Four</a></p>
<p class="toc1"><span href="#/Text/8chap5#chap5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc1"><span href="#/Text/9chap6#chap6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc1"><span href="#/Text/10chap7#chap7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc1"><span href="#/Text/11chap8#chap8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc1"><span href="#/Text/12chap9#chap9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc1"><span href="#/Text/13chap10#chap10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc1"><span href="#/Text/14chap11#chap11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc1"><span href="#/Text/15chap12#chap12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc1"><span href="#/Text/16chap13#chap13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="toc1"><span href="#/Text/17chap14#chap14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="toc1"><span href="#/Text/18chap15#chap15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="toc1"><span href="#/Text/19chap16#chap16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="toc1"><span href="#/Text/20chap17#chap17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="toc1"><span href="#/Text/21chap18#chap18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="toc1"><span href="#/Text/22chap19#chap19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="toc1"><span href="#/Text/23chap20#chap20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="toc1"><span href="#/Text/24chap21#chap21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="toc1"><span href="#/Text/25chap22#chap22" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="toc1"><span href="#/Text/26chap23#chap23" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="toc1"><span href="#/Text/27chap24#chap24" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="toc1"><span href="#/Text/28chap25#chap25" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="toc1"><span href="#/Text/29chap26#chap26" title="Link target outside of Sample">Chapter Twenty-Six</span></p>
<p class="toc1"><span href="#/Text/30chap27#chap27" title="Link target outside of Sample">Chapter Twenty-Seven</span></p>
<p class="toc1"><span href="#/Text/31chap28#chap28" title="Link target outside of Sample">Chapter Twenty-Eight</span></p>
<p class="toc1"><span href="#/Text/32chap29#chap29" title="Link target outside of Sample">Chapter Twenty-Nine</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/Text/teaser00" title="Link target outside of Sample">Preview: <i>Spiced to Death</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?7d6903a0